var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.color},on:{"mouseover":function () { return _vm.setHoveredVariable(_vm.target); },"mouseleave":function () { return _vm.setHoveredVariable(undefined); }}},[_vm._v("\n  "+_vm._s(_vm.target)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }